import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "axios";
import TextInput from "components/Input/TextInput.js";
import FloatInput from "components/Input/FloatInput";
import {
  CustomSelect,
} from "components/Input/Index.js";
import uuid from "react-uuid";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import moment from "moment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import CustomSwitch from "components/Input/CustomSwitch.js";
import { putPoint } from "services/ConfigServices";
import styled from "styled-components";
import { dico } from "variables/lists/dico";
import { campaigncharttext } from "variables/MBM/campaign";
import {  chartgranularityData, charttypefullData, 
   chartgranularityfullData, charttypeselectData , chartgranularityselectData} from "variables/lists/vues";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";

import { vuepagetext } from "variables/vues";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import DataTable from "react-data-table-component";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "28ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "28ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

function ChartDialog(props) {
  const { closeModal, charts, existingChartsData, setCharts, currentView, setModification } = props;

  const [prefilteredCharts, setPrefilteredCharts] = useState(existingChartsData);
  const [type, setType] = useState("all");
  const [granularity, setGranularity] = useState("all");
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [existingcharts, setExistingcharts] = useState("");

  const handleTypeChange = (event) => {
    setType(event.target.value);
  };
  const handleGranularityChange = (event) => { setGranularity(event.target.value); };

  useEffect(() => {
    let tmpprefilteredCharts = [...existingChartsData];
    if (type !== 'all') {
      tmpprefilteredCharts = tmpprefilteredCharts.filter((chart) => chart.type.includes(type));
    }
    if (granularity !== 'all')
    {
      tmpprefilteredCharts = tmpprefilteredCharts.filter((chart) => chart.granularity === granularity);
    }
    setPrefilteredCharts(tmpprefilteredCharts);
  }, [type, granularity]);

  const classes = useStyles();


  const handleSubmit = (event) => {
    let chartstmp = [...charts];
    let position = chartstmp.length + 1;
    existingcharts.map((chart) => {
      let newchart = {};
      newchart.source = 'existing';
      newchart.id = chart.id;
      newchart.version = chart.version;
      newchart.position = position;
      position++;
      chartstmp.push(newchart);
    });
    setCharts(chartstmp);
    currentView.charts = chartstmp;
    closeModal();
    setModification(true);
  };

  useEffect(() => {
    if (!existingcharts)
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  }, [existingcharts]);


  const chartsColumns = [
    {
      name: vuepagetext.chartname,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.name
    },
    {
      name: vuepagetext.charttype,
      selector: (row) => row.type,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => charttypefullData.find((a) => a.id == row.type)?.name || ""
    },
    {
      name: vuepagetext.chartgranularity,
      selector: (row) => row.granularity,
      sortable: true,
      cell: (row) => chartgranularityfullData.find((a) => a.id == row.granularity)?.name || ""
    },
  ]

  const [filterTextChart, setFilterTextChart] = useState("");
  const [resetPaginationToggleChart, setResetPaginationToggleChart] = useState(false);
  const SearchComponentChart = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );
  const filteredItemsCharts = prefilteredCharts.filter(
    (item) =>
      (item.name && item.name.toLowerCase().includes(filterTextChart.toLowerCase()))
  );
  const subHeaderComponentMemoChart = useMemo(() => {
    const handleClearChart = () => {
      if (filterTextChart) {
        setResetPaginationToggleChart(!resetPaginationToggleChart);
        setFilterTextChart("");
      }
    };
    const onFilterTextChart = (e) => setFilterTextChart(e.target.value);

    return (
      <>
        <TableName>Graphiques disponibles</TableName>
        <SearchComponentChart
          key="SearchComponentChart"
          onFilter={onFilterTextChart}
          onClear={handleClearChart}
          filterText={filterTextChart}
        />
      </>
    );
  }, [filterTextChart, resetPaginationToggleChart, prefilteredCharts]);

  const handleSelectedRowsChange = (selection) => {
    setExistingcharts(selection.selectedRows);
  };

  return (
    <>

      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <GridContainer>
                    <GridItem xs={12} sm={7} md={7}>
                      <div>
                        <CustomSelect
                          inputTitle={vuepagetext.charttype}
                          selectValue={type}
                          handleSelectValueChange={handleTypeChange}
                          data={charttypeselectData}
                        />
                      </div>
                    </GridItem>
                    <GridItem xs={12} sm={7} md={7}>
                      <div>
                        <CustomSelect
                          inputTitle={vuepagetext.chartgranularity}
                          selectValue={granularity}
                          handleSelectValueChange={handleGranularityChange}
                          data={chartgranularityselectData}
                        />
                      </div>
                    </GridItem>
                  </GridContainer>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
                    noDataComponent={<NoData>{"Aucun graphique"}</NoData>}
                    noHeader={true}
                    columns={chartsColumns}
                    persistTableHead
                    pagination
                    subHeader
                    data={filteredItemsCharts}
                    paginationComponentOptions={{
                      noRowsPerPage: false,
                      rowsPerPageText: "Lignes par page",
                      rangeSeparatorText: "sur",
                      selectAllRowsItem: false,
                      selectAllRowsItemText: "Selectionner toutes les lignes",
                    }}
                    onSelectedRowsChange={handleSelectedRowsChange}
                    selectableRows={true}
                    defaultPageSize={10}
                    filterable={true}
                    defaultSortFieldId={1}
                    manual={true}
                    paginationResetDefaultPage={resetPaginationToggleChart}
                    subHeaderComponent={subHeaderComponentMemoChart}
                  />
                </GridItem>
              </GridContainer>
            </div>
          </GridItem>
        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Ajouter
        </Button>
      </form>

    </>
  );
}

export default ChartDialog;
